import debounce from "lodash.debounce";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormDashboardLabel as Label,
  FormDashboardInput as Input,
  FormRow,
  PinPointInput,
  FormLabel,
} from "../../../components";
import { provinceFirstLabel } from "../../../constants";
import { CityDropdown } from "../../cities/components/city-dropdown";
import { CitiesProvider } from "../../cities/hook";
import { useInternationalization } from "../../i18n";
import { ProvinceDropdown } from "../../provinces/components/province-dropdown";
import { ProvincesProvider } from "../../provinces/hook";
import { updateForm } from "../slice";

const FormLocation = () => {
  const dispatch = useDispatch()
  const translation = useSelector(state => state.translation.data)
  const { translate, language } = useInternationalization()
  const form = useSelector(state => state.eventForm.data)
  const [showProvinceInput, setShowProvinceInput] = React.useState(false)

  const [defaultProvince, setDefaultProvince] = React.useState({})

  React.useEffect(() => {
    setShowProvinceInput(false)

    if(form.province){
      setDefaultProvince(form.province)
    }

    setTimeout(() => {
      setShowProvinceInput(true)
    }, 100)
  }, [form])

  const handleUpdateForm = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const handlePinPoint = (value) => {
    const result = `${value.lat}, ${value.lng}`
    dispatch(updateForm({key:'pin_point', value: result}))
  }

  return (
    <React.Fragment>
      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('GENERAL', 'location')} ({translate('GENERAL', 'offline')})
      </p>
      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <ProvincesProvider>
            {
              showProvinceInput &&
              <ProvinceDropdown defaultValue={defaultProvince} updateForm={handleUpdateForm} />
            }
          </ProvincesProvider>
        </div>
        <div className="w-full lg:w-1/2 px-4">
          {
            (form.province && form.province.value) ? (
              <CitiesProvider provinceId={form.province?.value}>
                <CityDropdown defaultValue={{label: form.city, value: form.city}} updateForm={handleUpdateForm} />
              </CitiesProvider>
            ) : (
              <>
                <FormLabel>
                  {translation.GENERAL.city[language.name]}
                </FormLabel>
                <p className="text-sm text-gray-600">
                  {provinceFirstLabel[language.name]}
                </p>
              </>
            )
          }
        </div>
      </div>

      <FormRow>
        <Label>{translate('GENERAL', 'address')}</Label>
        <Input
          className="w-full"
          defaultValue={form.address}
          name="address"
          onChange={(e) => {e.persist(); handleUpdateForm(e)}}
        />
      </FormRow>

      <div className="mb-8">
        <Label>Pin Point</Label>
        <PinPointInput onChange={handlePinPoint}/>
      </div>
    </React.Fragment>
  )
}

export { FormLocation }
